// ==========================================================================
// React Query Hook for Weather Data
// ==========================================================================

import { useQuery } from '@tanstack/react-query';
import { getWeather } from '@/services/weather.service';

// Query keys
export const weatherKeys = {
  all: ['weather'] as const,
  current: () => [...weatherKeys.all, 'current'] as const,
};

/**
 * Hook to fetch current weather and 7-day forecast
 * Only runs when user is authenticated (has access_token)
 */
export function useWeather(enabled = true) {
  return useQuery({
    queryKey: weatherKeys.current(),
    queryFn: getWeather,
    enabled: enabled && !!localStorage.getItem('access_token'),
    staleTime: 30 * 60 * 1000, // Data fresh for 30 min (server caches same duration)
    gcTime: 60 * 60 * 1000, // Keep in cache for 1 hour
    retry: (failureCount, error) => {
      const status = (error as { response?: { status?: number } })?.response?.status;
      // Don't retry on 401 (unauthenticated) or 422 (no location confirmed)
      if (status === 401 || status === 422) return false;
      return failureCount < 2;
    },
  });
}
